import React, { useEffect, useRef } from 'react';
import { GoogleUser } from '../types';
import { initializeGoogleSignIn, isGoogleAuthConfigured } from '../services/auth';

interface GoogleSignInButtonProps {
  onSignIn: (user: GoogleUser, token: string) => void;
  isDarkMode: boolean;
}

export const GoogleSignInButton: React.FC<GoogleSignInButtonProps> = ({ onSignIn, isDarkMode }) => {
  const buttonRef = useRef<HTMLDivElement>(null);
  const isConfigured = isGoogleAuthConfigured();

  useEffect(() => {
    if (!isConfigured) return;

    // Wait for Google script to load
    const checkGoogleLoaded = setInterval(() => {
      if (window.google) {
        clearInterval(checkGoogleLoaded);
        initializeGoogleSignIn(onSignIn, buttonRef.current);
      }
    }, 100);

    // Cleanup
    return () => clearInterval(checkGoogleLoaded);
  }, [onSignIn, isConfigured]);

  if (!isConfigured) {
    return (
      <div className={`text-xs text-center ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`}>
        Google Sign-In not configured
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center gap-2">
      <div 
        ref={buttonRef} 
        className="google-signin-button"
        style={{ minHeight: '44px' }}
      />
    </div>
  );
};
